import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.sucursales.data = data;
  });
};

const sucursal = async (store, params = {}) => {
  store.setState((state) => {
    state.app.usuarios.sucursales.busy = true;
  });

  try {
    const response = await Http.get(`api/catalogos/sucursal`, { params });

    store.setState((state) => {
      state.app.usuarios.sucursales.data = response.data;
      state.app.usuarios.sucursales.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.sucursales.error = error.data || error;
      state.app.usuarios.sucursales.busy = false;
    });
  }
};

const UsuarioSucursalStore = {
  state: () => initialState,
  actions: {
    sucursal,
    change,
  },
};

export default UsuarioSucursalStore;
